import {
  loadFindRideTranslations,
  findRideTranslations,
} from "./FindRideTranslationsLoader";
import type { FindRideTranslationKeys } from "./translations/en";

export function tFindRide(
  key: FindRideTranslationKeys,
  vars?: Record<string, string | number>
): string {
  const catalog = loadFindRideTranslations();
  let value = catalog[key] ?? findRideTranslations[key] ?? key;
  if (vars) {
    for (const [name, replacement] of Object.entries(vars)) {
      value = value.replace(`{${name}}`, String(replacement));
    }
  }
  return value;
}

export { findRideTranslations, loadFindRideTranslations };
